<template>
  <div>
    <ValidationObserver
      ref="observer"
      class="needs-validation form-custom-format"
      :class="{ 'was-validated': validated }"
      tag="form"
      @submit.prevent="onSubmitForm"
    >
    <el-dialog
      title="Product Type"
      :visible.sync="syncModal"
      :close-on-click-modal="false"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="820px"
      class="text-left brand-dialog"
      @closed="dialogState(false)"
    >
      <mdb-container class="mt-0 mb-0">
       
        <ThatsAutocomplete
          labelClass="col-sm-3"
          fieldClass="col-sm-9 pl-0"
          label="Department"
          vid="department_id"
          name="department_id"
          v-model="department_id"
          :options="departments"
          :reduce="department => department.id"
          :reduceLabel="'name'"
          :rules="'required'"
          :disabled="formLoading"
          :addButton="true"
          :appendButton="false"
          @newWindow="openDepartmentDialog"
          @input="departmentChanged"
        />
        <ThatsAutocomplete
          labelClass="col-sm-3"
          fieldClass="col-sm-9 pl-0"
          label="Category"
          vid="category_id"
          name="category_id"
          v-model="form.category_id"
          :options="filteredCategories"
          :reduce="category => category.id"
          :reduceLabel="'name'"
          :rules="'required'"
          :disabled="formLoading"
          :addButton="true"
          :appendButton="false"
          @newWindow="openCategoryDialog"
        />
        <ThatsInput
          labelClass="col-sm-3"
          fieldClass="col-sm-9 pl-0"
          label="Name"
          vid="name"
          name="name"
          v-model="form.name"
          :validated="validated"
          :rules="'required'"
          :show_error="true"
          size="sm"
        />
        <ThatsInput
          labelClass="col-sm-3"
          fieldClass="col-sm-9 pl-0"
          label="Arabic Name"
          placeholder="Arabic Name"
          vid="arabic_name"
          name="arabic_name"
          v-model="form.arabic_name"
          :validated="validated"
          :rules="''"
          :show_error="true"
          size="sm"
          :inputclass="['text-right']"
        />
        <ThatsTextarea
          labelClass="col-sm-3"
          fieldClass="col-sm-9 pl-0"
          label="Description"
          vid="description"
          name="description"
          v-model="form.description"
          :validated="validated"
          :rules="''"
          size="sm"
        />
        <ThatsRadio
          labelClass="col-sm-3"
          fieldClass="col-sm-9 pl-0"
          label="Status"
          vid="active"
          name="active"
          orientation="inline"
          :data="statusOptions"
          v-model="form.active"
          :validated="validated"
          :rules="'required'"
          size="sm"
        />
        <ThatsMultiSelect
          labelClass="col-sm-3"
          fieldClass="col-sm-9 pl-0"
          label="Attributes"
          vid="product_attributes"
          name="product_attributes"
          v-model="selectedAttributeIds"
          :options="attributeOptions"
          :reduce="attribute => attribute.id"
          :reduceLabel="'name'"
          :multiple="true"
          :rules="''"
          :noOptionsButton="true"
          :disabled="formLoading || attributesLoading"
          @newWindow="openAttributeDialog"
        />
        <div v-if="mappingRows.length" class="product-type-attributes-table table-responsive">
          <table class="table table-sm table-bordered mb-0">
            <thead>
              <tr>
                <th>Attribute</th>
                <th>Type</th>
                <th class="text-center">Mandatory</th>
                <th style="width: 120px">Order</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in mappingRows" :key="row.id">
                <td>{{ row.name }}</td>
                <td>{{ row.data_type === 'BOOLEAN' ? 'Yes/No' : row.data_type }}</td>
                <td class="text-center"><el-checkbox v-model="row.mandatory"></el-checkbox></td>
                <td><el-input-number v-model="row.display_order" :min="0" :step="1" size="small" controls-position="right" /></td>
              </tr>
            </tbody>
          </table>
        </div>
      </mdb-container>

      <template slot="footer">
        <mdb-btn v-if="formStatus === 'update'" color="elegant" size="sm" @click.native="openHistoryDialog">
          History
        </mdb-btn>
        <mdb-btn color="elegant" size="sm" :disabled="formLoading" @click.native="onSubmitForm">
          <span v-if="formLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {{ formLoading ? 'Loading...' : 'Save' }}
        </mdb-btn>
        <mdb-btn color="grey" size="sm" @click.native="closeDialog">Close</mdb-btn>
      </template>
    </el-dialog>
    </ValidationObserver>
    <ProductDepartmentForm ref="productDepartmentForm" @success="departmentCreated" />
    <CategoryForm ref="categoryForm" @success="categoryCreated" />
    <ProductAttributeForm ref="productAttributeForm" @success="attributeCreated" />
    <HistoryDialog ref="historyDialog" />
  </div>
</template>

<script>
import { mdbBtn, mdbContainer } from 'mdbvue';
import { ValidationObserver } from 'vee-validate';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { ApiHttpService } from '../../services';
import {
  ThatsInput,
  ThatsAutocomplete,
  ThatsRadio,
  ThatsTextarea,
  ThatsMultiSelect
} from '../../components/thats/Thats';
import ProductDepartmentForm from '../product-department/ProductDepartmentForm';
import CategoryForm from '../category/CategoryForm';
import ProductAttributeForm from '../product-attribute/ProductAttributeForm';
import HistoryDialog from '../../components/thats/HistoryDialog.vue';

export default {
  components: {
    ValidationObserver,
    ThatsInput,
    ThatsAutocomplete,
    ThatsRadio,
    ThatsTextarea,
    ThatsMultiSelect,
    ProductDepartmentForm,
    CategoryForm,
    ProductAttributeForm,
    HistoryDialog,
    mdbBtn,
    mdbContainer
  },

  data() {
    return {
      validated: false,
      form: this.formVar(),
      department_id: null,
      departments: [],
      categories: [],
      attributeOptions: [],
      selectedAttributeIds: [],
      mappingRows: [],
      attributesLoading: false,
      formLoading: false,
      response: {
        error: null,
        message: null
      },
      statusOptions: [
        { label: 'Active', value: 'true' },
        { label: 'Inactive', value: 'false' }
      ],
      syncModal: false
    };
  },

  created() {
    this.optionsHandler();
  },

  methods: {
    ...mapActions('ProductTypeModule', ['storeRecord', 'updateRecord']),
    ...mapMutations('ProductTypeModule', ['setFormStatusCreate']),
    ...mapMutations('HistoryModule', ['setModule', 'setRecordId']),

    formVar() {
      return {
        category_id: null,
        name: null,
        arabic_name: null,
        description: null,
        attr: { },
        active: 'true',
        sort_order: 0
      };
    },

    openHistoryDialog() {
      if (!this.form || !this.form.id) {
        return;
      }

      this.setModule('product-type');
      this.setRecordId(this.form.id);
      this.$refs.historyDialog.openDialog();
    },

    optionsHandler() {
      ApiHttpService.getRequest('product-departments').then((response) => {
        this.departments = response.data.data || response.data || [];
      });

      ApiHttpService.getRequest('category-master/all').then((response) => {
        this.categories = response.data.data || response.data || [];
        this.syncDepartment();
      });

      this.fetchAttributeOptions();
    },

    departmentChanged(value) {
      if (value !== this.department_id) {
        this.department_id = value;
      }

      if (this.form.category_id && !this.filteredCategories.some(category => String(category.id) === String(this.form.category_id))) {
        this.form.category_id = null;
      }
    },

    syncDepartment() {
      if (!this.form.category_id) {
        return;
      }

      const category = this.categories.find(item => String(item.id) === String(this.form.category_id));
      if (category) {
        this.department_id = category.department_id;
      }
    },

    openDialog() {
      this.syncModal = true;
      if (!this.attributeOptions.length) {
        this.fetchAttributeOptions();
      }
    },

    closeDialog() {
      this.syncModal = false;
    },

    openDepartmentDialog() {
      this.$refs.productDepartmentForm.openDialog();
    },

    openCategoryDialog() {
      this.$refs.categoryForm.openDialog();
    },

    openAttributeDialog() {
      this.$refs.productAttributeForm.openDialog();
    },

    fetchAttributeOptions() {
      this.attributesLoading = true;
      return ApiHttpService.getRequest('product-attributes', { length: 1000 }).then((response) => {
        const attributes = response.data.data || response.data || [];
        this.attributeOptions = attributes.filter(attribute =>
          attribute.active === undefined || [true, 1, '1', 'true'].includes(attribute.active)
        );
      }).finally(() => {
        this.attributesLoading = false;
      });
    },

    departmentCreated(response) {
      const department = response && response.data ? response.data : response;

      if (department && department.id) {
        this.departments = [department].concat(
          this.departments.filter(item => String(item.id) !== String(department.id))
        );
        this.department_id = department.id;
        this.form.category_id = null;
        return;
      }

      ApiHttpService.getRequest('product-departments').then((result) => {
        this.departments = result.data.data || result.data || [];
      });
    },

    categoryCreated(response) {
      const category = response && response.data ? response.data : response;

      ApiHttpService.getRequest('category-master/all').then((result) => {
        this.categories = result.data.data || result.data || [];

        if (category && category.id) {
          this.department_id = category.department_id;
          this.form.category_id = category.id;
        } else {
          this.syncDepartment();
        }
      });
    },

    attributeCreated(response) {
      const attribute = response && response.data ? response.data : response;

      this.fetchAttributeOptions().then(() => {
        if (attribute && attribute.id && this.attributeOptions.some(item => String(item.id) === String(attribute.id))) {
          if (!this.selectedAttributeIds.some(id => String(id) === String(attribute.id))) {
            this.selectedAttributeIds = this.selectedAttributeIds.concat(attribute.id);
          }
        }
      });
    },

    syncAttributeRows() {
      const existing = this.mappingRows.reduce((result, row) => {
        result[row.id] = row;
        return result;
      }, {});

      this.mappingRows = this.selectedAttributeIds.map((id, index) => {
        const attribute = this.attributeOptions.find(item => String(item.id) === String(id));
        if (existing[id]) {
          return {
            ...existing[id],
            data_type: existing[id].data_type || (attribute && attribute.data_type) || '',
          };
        }

        return {
          id,
          name: attribute ? attribute.name : id,
          data_type: attribute ? attribute.data_type : '',
          mandatory: false,
          filterable: true,
          display_order: index,
        };
      });
    },

    async fetchAttributeMappings(productTypeId) {
      if (!productTypeId) return;

      this.attributesLoading = true;
      try {
        const response = await ApiHttpService.getRequest(`product-types/${productTypeId}/attributes`);
        const mappings = response.data.data || response.data || [];
        this.mappingRows = mappings.map(attribute => ({
          id: attribute.id,
          name: attribute.name,
          data_type: attribute.data_type || '',
          mandatory: !!(attribute.pivot && attribute.pivot.mandatory),
          filterable: true,
          display_order: attribute.pivot ? attribute.pivot.display_order : 0,
        }));
        this.selectedAttributeIds = this.mappingRows.map(row => row.id);
      } finally {
        this.attributesLoading = false;
      }
    },

    async saveAttributeMappings(productTypeId) {
      if (!productTypeId) return;

      await ApiHttpService.update(`product-types/${productTypeId}/attributes`, {
        attributes: this.mappingRows.map(row => ({
          id: row.id,
          mandatory: !!row.mandatory,
          filterable: !!row.filterable,
          display_order: Number(row.display_order) || 0,
        })),
      });
    },

    async onSubmitForm() {
      if (this.formLoading) {
        return;
      }

      this.validated = true;

      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return;
      }

      this.formLoading = true;

      const payload = {
        ...this.form,
        active: [true, 1, '1', 'true'].includes(this.form.active),
        sort_order: Number(this.form.sort_order)
      };

      const request = this.formStatus === 'create'
        ? this.storeRecord(payload)
        : this.updateRecord(payload);

      request.then((response) => {
        const productType = response.data || response;
        return this.saveAttributeMappings(productType.id || this.form.id).then(() => response);
      }).then((response) => {
        this.$ThatsNotify.success({
          message: this.formStatus === 'create' ? undefined : 'Record was successfully updated'
        });
        this.$emit('success', response);
        this.closeDialog();
        this.FormResetter();
      }).catch((error) => {
        this.formLoading = false;
        this.response.error = 1;

        const responseData = error.response && error.response.data
          ? error.response.data
          : null;

        if (responseData && responseData.errors) {
          const fieldErrors = Object.keys(responseData.errors).reduce((errors, field) => {
            const messages = responseData.errors[field];
            errors[field] = Array.isArray(messages) ? messages : [messages];
            return errors;
          }, {});

          this.$refs.observer.setErrors(fieldErrors);
        } else if (responseData && responseData.message) {
          this.$refs.observer.setErrors({
            name: [responseData.message]
          });
        } else if (error.request) {
          this.response.message = error.request;
        } else {
          this.response.message = error.message;
        }
      });
    },

    FormResetter() {
      this.form = this.formVar();
      this.department_id = null;
      this.validated = false;
      this.formLoading = false;
      this.selectedAttributeIds = [];
      this.mappingRows = [];
      this.attributesLoading = false;
      this.setFormStatusCreate();

      this.$nextTick(() => {
        if (this.$refs.observer) {
          this.$refs.observer.reset();
        }
      });
    },

    normalizeStatus() {
      this.form.active = [true, 1, '1', 'true'].includes(this.form.active)
        ? 'true'
        : 'false';
    },

    dialogState(state) {
      if (!state) {
        this.FormResetter();
      }
    },

    emitDelete() {
      this.$emit('delete', this.formRecord);
    }
  },

  computed: {
    ...mapGetters('ProductTypeModule', ['formStatus', 'formRecord']),
    filteredCategories() {
      if (!this.department_id) {
        return [];
      }

      return this.categories.filter(category => String(category.department_id) === String(this.department_id));
    }
  },

  watch: {
    formRecord(value) {
      if (this.formStatus === 'update' && value) {
        this.form = JSON.parse(JSON.stringify(value.row || value));

        this.normalizeStatus();
        this.syncDepartment();
        this.fetchAttributeMappings(this.form.id);
      }
    },
    categories() {
      this.syncDepartment();
    },
    selectedAttributeIds() {
      this.syncAttributeRows();
    },
   
  }
};
</script>

<style scoped>
.product-type-attributes-table {
  margin: 0 0 12px 25%;
  width: 75%;
}
</style>
